import pluralize from "pluralize";

export const getCategoryWiseItems = (posMenu = []) => {
  const categoryMap = new Map();

  posMenu.forEach((item) => {
    const id = item.id || item._id;
    const name = item.name || "";
    let categoryId, categoryName;

    if (item?.category) {
      if (typeof item.category === "object") {
        categoryId = item.category.id || item.category._id;
        categoryName = item.category.name || "";
      } else if (typeof item.category === "string") {
        categoryId = item.category_id;
        categoryName = item.category || "";
      }
    } else if (item.category_id) {
      categoryId = item.category_id || "";
      categoryName = item.category_name || "";
    } else {
      categoryId = "others";
      categoryName = "Others";
    }

    const category = categoryMap.get(categoryId);

    if (category) {
      const existingItem = category.category_items.find(
        (existingItem) => existingItem.id === id
      );
      if (!existingItem) {
        category.category_items.push({
          id,
          name,
        });
      }
    } else {
      categoryMap.set(categoryId, {
        category_id: categoryId,
        category_name: categoryName,
        category_items:
          id && name?.length > 0
            ? [
                {
                  id,
                  name,
                },
              ]
            : [],
      });
    }
  });

  return Array.from(categoryMap.values());
};

export const isAdvancedCashback = (cbType) =>
  cbType === "lifetime_spent" || cbType === "order_value";

export const commonLoyaltySettingsState = {
  // earn on subtotal or total bill
  earn_points_on: {
    sub_total: false,
  },

  // for earning cashback in cashback loyalty
  // or
  // for earning points in visits based loyalty
  min_bill_amount: {
    active: false,
    amount: "",
  },

  // for redeeming cashback
  redemption_limit: {
    active: false,
    percentage: "",
    fixed: "",
    activeTab: "", // fixed, percentage
  },

  // min. bill for redeeming cashback
  min_bill_for_redemption: {
    active: false,
    amount: "",
  },

  // for max. cashback redeemed on a bill amount
  redemption_cap_on_max_bill: {
    active: false,
    value: "",
  },

  max_points_earn: {
    active: false,
    value: "",
  },

  exclude_payment_types: {
    list: [],
    is_active: false,
  },

  manual_discount: false,
};

export const initLoyaltyState = {
  step: "theme", // theme, title, points, rewards, terms
  visitedSteps: ["theme"],

  title: "",
  description: "",

  visit_made: 1,
  amount_spent: 1,
  points_earned: 1,

  rewards: [],

  activeRewardIndex: 0,

  deleteRewardId: "",
  deleteRewardIndex: "",
  isDeleteRewardOpen: false,

  logo: "",
  tempLogoKey: "",
  tempLogoImg: "",
  logoFileName: "",

  banner: "",
  tempBanner: "",
  colors: {
    text: "",
    theme: "",
  },

  terms: "",

  tiers: [],

  // settings
  points_branding: {
    active: false,
    name: "",
  },

  // for adding interval between two visits.
  visit_interval: {
    active: false,
    duration: "",
    period: "",
  },

  // for blocking same day redemption
  earn_redeem_same_day: {
    active: false,
  },

  // exclude items
  exclude_items_arr: [],

  ...commonLoyaltySettingsState,
};

export const cashbackLoyaltyTypes = [
  {
    key: "basic",
    text: "Basic",
    heading: "Simple Cashback",
    subHeading: "Most used loyalty type",
    icon: "/assets/images/loyalty/advancedCashback/ok_hand.svg",
    description:
      "Customers earn a fixed percentage of their order value back as a reward on every purchase.",
  },
  {
    key: "lifetime_spent",
    text: "Lifetime Spent",
    subHeading: "This can help increase the lifetime spend",
    icon: "/assets/icons/money-mouth-face.svg",
    heading: "Advanced Cashback - Lifetime spent",
    description:
      "Customers earn rewards based on their total lifetime spending with your business.",
  },
  // {
  //   key: "order_value",
  //   text: "Total Order Value",
  //   subHeading: "This can help increase AOV",
  //   icon: "/assets/images/loyalty/advancedCashback/shopping-bags.svg",
  //   heading: "Advanced Cashback - Order Value",
  //   description:
  //     "Customers earn rewards based on their spend per order. Higher spend, higher rewards.",
  // },
];

export const cashbackTypeName = (type) => {
  switch (type) {
    case "lifetime_spent":
      return "Lifetime Spent";
    case "order_value":
      return "Total Order Value";
    case "basic":
    default:
      return "Simple Cashback";
  }
};

export const orderValueArr = [
  { minValue: 0, maxValue: 500, points: 10 },
  { minValue: 501, maxValue: 2000, points: 20 },
  { minValue: 2001, maxValue: 100000, points: 30 },
];

export const getPaymentMethodsTxt = (selectedPaymentOptions) => {
  const labels = selectedPaymentOptions?.map((option) => {
    const label = option.typeName || option.methodName;
    if (label === "upi") return label.toUpperCase();
    else if (!label.startsWith("@"))
      return label.charAt(0).toUpperCase() + label.slice(1);
    else return label;
  });
  return labels.join(", ");
};

export const getStepFromQueryParams = (location) => {
  const searchParams = new URLSearchParams(location.search);
  return searchParams.get("step");
};

export const getExcludeItemTermText = (pointsBranding) => {
  const brandingName = pluralize(
    pointsBranding?.active ? pointsBranding?.name : "point",
    2
  );
  return `Loyalty ${brandingName} won’t be earned on certain items.`;
};

export const getExcludePaymentTermText = (loyaltyType) =>
  `No Loyalty ${
    loyaltyType === "cashback" ? "cashback" : "points"
  } will be earned for certain payment methods.`;
